import React from 'react';
import { Building } from 'lucide-react';

export default function VaultPanel({ project }) {
    return (
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-6 md:p-8 border border-white/10 shadow-2xl text-white">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-white/10 rounded-xl backdrop-blur-sm">
                    <Building className="text-white" size={24} />
                </div>
                <div>
                    <h3 className="text-lg font-black uppercase tracking-tight">Carbon Vault Transparency</h3>
                    <p className="text-xs text-gray-400 font-medium">Vault ID: {project.vault.vault_id}</p>
                </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
                <div className="space-y-2">
                    <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Deposited</p>
                    <p className="text-2xl font-black">{project.vault.total_capacity.toLocaleString()}</p>
                    <p className="text-[10px] font-bold text-gray-500 uppercase">tCO₂e</p>
                </div>
                <div className="space-y-2">
                    <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Tokenized</p>
                    <p className="text-2xl font-black">{project.vault.tokens_issued.toLocaleString()}</p>
                    <p className="text-[10px] font-bold text-gray-500 uppercase">TCO2 Tokens</p>
                </div>
                <div className="space-y-2">
                    <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Circulating</p>
                    <p className="text-2xl font-black text-blue-400">{project.vault.tokens_circulating.toLocaleString()}</p>
                    <p className="text-[10px] font-bold text-gray-500 uppercase">TCO2 Tokens</p>
                </div>
                <div className="space-y-2">
                    <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Retired</p>
                    <p className="text-2xl font-black text-emerald-400">{project.vault.credits_retired.toLocaleString()}</p>
                    <p className="text-[10px] font-bold text-gray-500 uppercase">tCO₂e</p>
                </div>
            </div>

            {/* Tokenization Progress Bar */}
            <div className="space-y-3 mb-6">
                <div className="flex justify-between items-center">
                    <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Tokenization Progress</span>
                    <span className="text-xs font-bold text-white">{Math.round((project.vault.tokens_issued / project.vault.total_capacity) * 100)}%</span>
                </div>
                <div className="relative h-3 w-full bg-white/10 rounded-full overflow-hidden">
                    <div
                        className="absolute inset-y-0 left-0 bg-gradient-to-r from-blue-500 to-emerald-400 rounded-full shadow-[0_0_10px_rgba(59,130,246,0.3)]"
                        style={{ width: `${(project.vault.tokens_issued / project.vault.total_capacity) * 100}%` }}
                    />
                </div>
            </div>

            {/* Distribution Chart */}
            <div className="space-y-3">
                <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Credit Distribution</span>
                <div className="flex h-4 rounded-full overflow-hidden">
                    <div
                        className="bg-blue-500"
                        style={{ width: `${(project.vault.tokens_circulating / project.vault.total_capacity) * 100}%` }}
                        title="Circulating"
                    />
                    <div
                        className="bg-emerald-500"
                        style={{ width: `${(project.vault.credits_retired / project.vault.total_capacity) * 100}%` }}
                        title="Retired"
                    />
                    <div
                        className="bg-gray-600"
                        style={{ width: `${((project.vault.total_capacity - project.vault.tokens_circulating - project.vault.credits_retired) / project.vault.total_capacity) * 100}%` }}
                        title="In Vault"
                    />
                </div>
                <div className="flex gap-6 text-[9px] font-bold">
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                        <span className="text-gray-400 uppercase">Circulating ({Math.round((project.vault.tokens_circulating / project.vault.total_capacity) * 100)}%)</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-emerald-500"></div>
                        <span className="text-gray-400 uppercase">Retired ({Math.round((project.vault.credits_retired / project.vault.total_capacity) * 100)}%)</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-gray-600"></div>
                        <span className="text-gray-400 uppercase">In Vault ({Math.round(((project.vault.total_capacity - project.vault.tokens_circulating - project.vault.credits_retired) / project.vault.total_capacity) * 100)}%)</span>
                    </div>
                </div>
            </div>

            <div className="mt-6 pt-6 border-t border-white/10">
                <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-2">Custodian</p>
                <p className="text-sm font-bold text-white uppercase">{project.vault.custodian}</p>
            </div>
        </div>
    );
}
